import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id"]

import { onMounted, useId, useTemplateRef } from 'vue';
import { Loader } from '@googlemaps/js-api-loader';


export default /*@__PURE__*/_defineComponent({
  __name: 'LocationDetailsMap',
  props: {
    center: {},
    markerPositions: {},
    busStops: {},
    zoom: {}
  },
  setup(__props: any) {

let map: google.maps.Map | null = null;
const id = useId();
const mapElement = useTemplateRef('mapElement');

const props = __props;

onMounted(async () => {
  const loader = new Loader({
    apiKey: 'AIzaSyDiP-0e-uI9Xkup13OeE-Lo3dL_QzbCIZE',
    version: 'weekly',
  });

  if (!mapElement.value) {
    return;
  }

  const { Map } = (await loader.importLibrary('maps')) as google.maps.MapsLibrary;
  const { AdvancedMarkerElement } = (await loader.importLibrary('marker')) as google.maps.MarkerLibrary;

  map = new Map(mapElement.value, {
    center: props.center,
    zoomControlOptions: {
      position: google.maps.ControlPosition.RIGHT_BOTTOM,
    },
    mapId: '6896da82777ebb1f',
    zoom: props.zoom || 17,
    disableDefaultUI: true,
    gestureHandling: 'cooperative',
    clickableIcons: false,
    fullscreenControl: false,
    fullscreenControlOptions: null,
    keyboardShortcuts: null,
    streetView: null,
    streetViewControl: false,
    streetViewControlOptions: null,
    scrollwheel: false,
    zoomControl: true,
  });

  for (const loc in props.markerPositions) {
    new AdvancedMarkerElement({
      map,
      position: {
        lat: props.markerPositions[loc].lat,
        lng: props.markerPositions[loc].lng,
      },
      content: new DOMParser().parseFromString(
        '<svg xmlns="http://www.w3.org/2000/svg" width="54" height="77" viewBox="0 0 54 77" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M27 76.334C27 76.334 53.5 47.9356 53.5 27.7784C53.5 12.6213 41.6355 0.333984 27 0.333984C12.3645 0.333984 0.5 12.6213 0.5 27.7784C0.5 47.9356 27 76.334 27 76.334Z" fill="#15BBBD"/><path d="M32.1605 32.125C27.5015 36.136 26.9491 44.6131 26.9491 44.6131L26.9251 44.3617C26.817 42.9968 26.0365 35.7529 21.8338 32.113C17.1748 28.1019 10.5586 27.0005 10.5586 27.0005C10.5586 27.0005 17.1748 25.9109 21.8338 21.8878C26.0485 18.2599 26.817 11.0041 26.9251 9.63912L26.9491 9.3877C26.9491 9.3877 27.5015 17.8648 32.1605 21.8758C36.8195 25.8869 43.4357 26.9885 43.4357 26.9885C43.4357 26.9885 36.8195 28.1139 32.1605 32.125Z" fill="white"/></svg>',
        'image/svg+xml'
      ).documentElement,
      zIndex: 20000,
    });
  }

  for (const busStop of props.busStops || []) {
    new AdvancedMarkerElement({
      map,
      position: {
        lat: busStop.lat,
        lng: busStop.lng,
      },
      content: new DOMParser().parseFromString(
        '<svg xmlns="http://www.w3.org/2000/svg" width="41" height="40" viewBox="0 0 41 40" fill="none"><path d="M0.630371 6.66667C0.630371 3.52397 0.630371 1.95262 1.60668 0.976311C2.58299 0 4.15434 0 7.29704 0H33.9637C37.1064 0 38.6777 0 39.6541 0.976311C40.6304 1.95262 40.6304 3.52397 40.6304 6.66667V33.3333C40.6304 36.476 40.6304 38.0474 39.6541 39.0237C38.6777 40 37.1064 40 33.9637 40H7.29704C4.15434 40 2.58299 40 1.60668 39.0237C0.630371 38.0474 0.630371 36.476 0.630371 33.3333V6.66667Z" fill="#15BBBD"/><path d="M12.1866 19.1111V16.4445C12.4319 16.4445 12.631 16.2453 12.631 16C12.631 15.7547 12.4319 15.5555 12.1866 15.5555C10.9608 15.5555 9.96436 16.5529 9.96436 17.7778V18.6667C9.96436 19.4018 10.5626 20 11.2977 20H12.1866C12.4319 20 12.631 19.8009 12.631 19.5555C12.631 19.3102 12.4319 19.1111 12.1866 19.1111Z" fill="white"/><path d="M29.0753 15.5555C28.83 15.5555 28.6309 15.7547 28.6309 16C28.6309 16.2453 28.83 16.4445 29.0753 16.4445V19.1111C28.83 19.1111 28.6309 19.3102 28.6309 19.5556C28.6309 19.8009 28.83 20 29.0753 20H29.9642C30.6993 20 31.2975 19.4018 31.2975 18.6667V17.7778C31.2975 16.5529 30.3011 15.5555 29.0753 15.5555Z" fill="white"/><path d="M17.5196 28.0002C17.2742 28.0002 17.0751 28.1993 17.0751 28.4446H14.4084C14.4084 28.1993 14.2093 28.0002 13.964 28.0002C13.7187 28.0002 13.5195 28.1993 13.5195 28.4446V29.3335C13.5195 30.0686 14.1177 30.6668 14.8529 30.6668H16.6307C17.3658 30.6668 17.964 30.0686 17.964 29.3335V28.4446C17.964 28.1993 17.7649 28.0002 17.5196 28.0002Z" fill="white"/><path d="M27.2973 28.0002C27.052 28.0002 26.8529 28.1993 26.8529 28.4446H24.1862C24.1862 28.1993 23.9871 28.0002 23.7418 28.0002C23.4964 28.0002 23.2974 28.1993 23.2974 28.4446V29.3335C23.2974 30.0686 23.8956 30.6668 24.6307 30.6668H26.4085C27.1436 30.6668 27.7418 30.0686 27.7418 29.3335V28.4446C27.7418 28.1993 27.5427 28.0002 27.2973 28.0002Z" fill="white"/><path d="M27.2977 9.3335H13.9644C12.7386 9.3335 11.7422 10.3308 11.7422 11.5557V26.6668C11.7422 27.8916 12.7386 28.889 13.9644 28.889H27.2977C28.5235 28.889 29.5199 27.8916 29.5199 26.6668V11.5557C29.5199 10.3308 28.5235 9.3335 27.2977 9.3335ZM15.7422 11.1113H25.5199C26.255 11.1113 26.8533 11.7095 26.8533 12.4446C26.8533 13.1797 26.255 13.7779 25.5199 13.7779H15.7422C15.007 13.7779 14.4088 13.1797 14.4088 12.4446C14.4088 11.7095 15.007 11.1113 15.7422 11.1113ZM15.7422 26.2223C15.007 26.2223 14.4088 25.6241 14.4088 24.889C14.4088 24.1539 15.007 23.5556 15.7422 23.5556C16.4773 23.5556 17.0755 24.1539 17.0755 24.889C17.0755 25.6241 16.4773 26.2223 15.7422 26.2223ZM25.5199 26.2223C24.7848 26.2223 24.1866 25.6241 24.1866 24.889C24.1866 24.1539 24.7848 23.5556 25.5199 23.5556C26.255 23.5556 26.8532 24.1539 26.8532 24.889C26.8532 25.6241 26.255 26.2223 25.5199 26.2223ZM27.7421 20.4446C27.7421 21.1797 27.1439 21.7779 26.4088 21.7779H14.8533C14.1181 21.7779 13.5199 21.1797 13.5199 20.4446V16.0001C13.5199 15.265 14.1181 14.6668 14.8533 14.6668H26.4088C27.1439 14.6668 27.7421 15.265 27.7421 16.0001V20.4446H27.7421Z" fill="white"/></svg>',
        'image/svg+xml'
      ).documentElement,
      zIndex: 20002,
    });
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    id: _unref(id),
    class: "map",
    ref_key: "mapElement",
    ref: mapElement
  }, null, 8, _hoisted_1))
}
}

})